import { WatermarkSettings } from './types';

export const watermarkSettings: WatermarkSettings = {
  componentVariants: {
    variant: {
      prop: 'variant',
      variants: {
        'visa-regular': {
          transform: 'scale(1.365)',
        },
        'visa-small': {
          transform: 'scale(1.065)',
        },
        'master-regular': {
          transform: 'scale(1)',
        },
        'master-small': {
          transform: 'scale(0.65)',
        },
      },
    },
  },
};
